import React, { useEffect, useState } from 'react';
import { Popconfirm, Table, } from 'antd';

import { fetchFromAddress, deleteFromAddress } from '../../utils/services/smtpConfigAPI';
import { MANAGE_SMTP_SERVER_CONFIGURATION as trans } from './TranslationValues';

const FromAddressTable = ({ domainId, address, fromAddressList, t }) => {

  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    address && setData([...data, ...address]);
    setIsFetching(false)
  }, [address])

  const handleDelete = async (id) => {
    const response = await deleteFromAddress(id);

    if (response.statusCode === 2408) {
      const newData = data.filter((item) => item.id !== id);
      setData([...newData]);
    };
  };

  useEffect(() => {
    const getAddressList = async () => {
      const response = await fetchFromAddress(domainId);
      if (response.data) {
        setData(response.data);
        setIsFetching(false)
      }
    };
    fromAddressList ? setData(fromAddressList) : getAddressList();

  }, []);

  const columns = [
    {
      title: t(trans.MANAGE_SMTP_SERVER_FROM_ADDRESS_LABEL.key, trans.MANAGE_SMTP_SERVER_FROM_ADDRESS_LABEL.value),
      dataIndex: 'emailFromAddress',
      key: 'emailFromAddress',
      render: (text, record) => (
        <>
          <div style={{ display: "flex", alignItems: 'center', gap: "20px" }} >
            {text}
          </div>

        </>
      ),
    },
    {
      title: t(trans.MANAGE_SMTP_SERVER_ACTION_LABEL.key, trans.MANAGE_SMTP_SERVER_ACTION_LABEL.value),
      key: 'action',
      dataIndex: 'action',
      render: (text, record) =>
        data.length >= 1 ? (
          <>
            <Popconfirm
              title={t(
                trans.DELETE_CONFIRMATION_MESSAGE.key,
                trans.DELETE_CONFIRMATION_MESSAGE.value,
              )}
              onConfirm={() => handleDelete(record.id)}
              cancelText={t(
                trans.CANCEL_DEFAULT_SMTP_CHANGES_BUTTON.key,
                trans.CANCEL_DEFAULT_SMTP_CHANGES_BUTTON.value,
              )}
              okText={t(
                trans.MANAGE_SMTP_SERVER_OK_LABEL.key,
                trans.MANAGE_SMTP_SERVER_OK_LABEL.value,
              )}
              okButtonProps={{style: {width: 'fit-content'}}}
              cancelButtonProps={{style: {width: 'fit-content'}}}
            >
              <a>
                {t(trans.DELETE_SMTP_SERVER_TOOLTIP.key, trans.DELETE_SMTP_SERVER_TOOLTIP.value)}
              </a>
            </Popconfirm>
          </>
        ) : null,
    },
  ];

  return (
    <Table
      loading={isFetching}
      rowClassName={() => 'editable-row'}
      bordered
      dataSource={data}
      columns={columns}
      pagination={false}
      className='addressList'
    />
  );
};

export default FromAddressTable;